import React from 'react'
import { jt, t } from 'ttag'

const WBLPromoteApplication = ({ profile, selectedCluster }) => {
  const cl = <b>{t`clusters`}</b>
  const occs = <b>{t`occupations`}</b>
  const participate = <b>{t`participate`}</b>
  const app = <b>{t`application`}</b>

  return (
    <div className="wbl-application-promotion-block">
      <div className="bg-image">
        <h4 className="profile-emphasized-heading main-title">{jt`How can I ${participate}?`}</h4>
        <ul className="profile-emphasized-heading">
          <li className="first">{jt`Explore the ${cl} and ${occs} you would like to pursue`}</li>
          <li className="second">{jt`Figure out how you would like to ${participate}`}</li>
          <li className="third">{jt`Submit an ${app}`}</li>
        </ul>
      </div>
    </div>
  )
}

export default WBLPromoteApplication
